<template>
  <div class="android_faq" style="margin-top: 92px;">
    <p class="category_big">
      <b>{{ title }}</b>
    </p>

    <div class="accordion accordion-flush" :id="`accordionExample${accordionId}`">

      <div class="accordion-item" v-for="(item, index) in list" >
        <h2 class="accordion-header" :id="`heading${item.id}`">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${item.id}`" aria-expanded="false" :aria-controls="`collapse${item.id}`">
            {{item.sbjctNm}}
          </button>
        </h2>
        <div :id="`collapse${item.id}`" class="accordion-collapse collapse" :aria-labelledby="`heading${item.id}`" :data-bs-parent="`#accordionExample${accordionId}`">
          <div class="accordion-body">
            <template v-for="(sub, index) in item.appFaqSubs">
              <div class="android_solution" v-if="sub.subtitlNm !=null && sub.subtitlNm !== ''">
                <p>
                  {{sub.subtitlNm}}
                </p>
              </div>
              <div :id="`carousel_faq_finish_${sub.id}`" class="carousel slide" data-bs-ride="carousel" data-bs-interval="false" data-bs-wrap="false">
                <div class="carousel-indicators">
                  <template v-for="i in 5" v-if="sub[`attFileN${i}`] != ''">
                    <button v-if="i==1" type="button" :data-bs-target="`#carousel_faq_finish_${sub.id}`" :data-bs-slide-to=(i-1)
                            class="active" aria-current="true" :aria-label="`Slide ${i}`" ref="firstSlideButton"></button>
                    <button v-else type="button" :data-bs-target="`#carousel_faq_finish_${sub.id}`" :data-bs-slide-to=(i-1)
                            :aria-label="`Slide ${i}`"></button>
                  </template>
                </div>
                <div class="carousel-inner">
                  <template v-for="i in 5" v-if="sub[`attFileN${i}`] != ''">
                    <div v-if="i==1" class="carousel-item active">
                      <!--                          <img src="@/assets/image/android_faq_finish_1_1@2x.png" class="d-block w-100" alt="...">-->
                      <img :src="sub[`attFileN${i}`]" :alt="sub[`attFileNameN${i}`]" class="d-block w-100">
                    </div>
                    <div v-else class="carousel-item">
                      <!--                          <img src="@/assets/image/android_faq_finish_1_2@2x.png" class="d-block w-100" alt="...">-->
                      <img :src="sub[`attFileN${i}`]" :alt="sub[`attFileNameN${i}`]" class="d-block w-100">
                    </div>
                  </template>
                </div>
                <button class="carousel-control-prev" type="button" :data-bs-target="`#carousel_faq_finish_${sub.id}`" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" :data-bs-target="`#carousel_faq_finish_${sub.id}`" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>

            </template>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqListView',
  props: [
    'list',
    'title',
    'accordionId',
  ],
  computed: {
  },
  updated() {
    if(this.$refs.firstSlideButton){
      for (const item of this.$refs.firstSlideButton) {
        item.click()
      }
    }

    for (const faqItem of this.list) {
      for (const sub of faqItem.appFaqSubs) {
        let idString = "#carousel_faq_finish_" + sub.id
        this.checkItemWithString(idString)
        $(idString).on("slid.bs.carousel", {
          fullId: idString
        }, this.checkItem)
      }
    }

  },
  methods: {
    checkItemWithString(string){
      let event = {data :{fullId:string}}
      this.checkItem(event)
    },
    checkItem(event) {
      let idString = event.data.fullId
      let $this;
      $this = $(idString);
      if ($(idString + " .carousel-inner .carousel-item:first").hasClass("active")) {
        $this.children(".carousel-control-prev").hide();
        $this.children(".carousel-control-next").show();
      }
      else if ($(idString + " .carousel-inner .carousel-item:last").hasClass("active")) {
        $this.children(".carousel-control-next").hide();
        $this.children(".carousel-control-prev").show();
      }
      else {
        $this.children(".carousel-control-next").show();
        $this.children(".carousel-control-prev").show();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/FaqListView.vue